module.exports = __webpack_public_path__ + "static/media/guide.a2418c76.jpg";